<template>
    <AuthenticatedLayout>
      <div class="tasks">
        <!-- Cabeçalho -->
        <header class="tasks-header">
          <h2>Tarefas</h2>                                          
            <el-button-group class="ml-4">
              <el-button @click="showFilters = !showFilters" type="primary">
                <el-icon><Filter /></el-icon>                
              </el-button>
              <el-button @click="toggleView" type="primary">
                <span v-if="isKanbanView">
                  <el-icon><List /></el-icon>
                </span>
                <span v-if="!isKanbanView">
                  <el-icon><Grid /></el-icon>
                </span>                
            </el-button>
            </el-button-group>
        </header>

        <el-form v-if="showFilters" label-position="top">
          <el-card class="task-filter">
            <h3>Filtrar Tarefas</h3>
            <el-row :gutter="20">
              <!-- Filtro por Autor -->
              <el-col :xs="24" :md="12" :lg="6">
                <el-form-item label="Autor">
                  <el-select filterable v-model="filters.author" placeholder="Selecione um autor" clearable>
                    <el-option 
                      v-for="author in activeUsers" 
                      :key="author.id" 
                      :label="author.name" 
                      :value="author.id" />
                  </el-select>
                </el-form-item>
              </el-col>
        
              <!-- Filtro por Responsável -->
              <el-col :xs="24" :md="12" :lg="6">
                <el-form-item label="Responsável">
                  <el-select filterable v-model="filters.assignedTo" placeholder="Selecione um responsável" clearable>
                    <el-option 
                      v-for="person in activeUsers" 
                      :key="person.id" 
                      :label="person.name" 
                      :value="person.id" />
                  </el-select>
                </el-form-item>
              </el-col>
        
              <!-- Filtro por Cliente -->
              <el-col :xs="24" :md="12" :lg="6">
                <el-form-item label="Cliente">
                  <el-select filterable v-model="filters.client" placeholder="Selecione um cliente" clearable>
                    <el-option 
                      v-for="client in activeClients" 
                      :key="client.id" 
                      :label="client.name" 
                      :value="client.id" />
                  </el-select>
                </el-form-item>
              </el-col>
        
              <!-- Filtro por Categoria -->
              <el-col :xs="24" :md="12" :lg="6">
                <el-form-item label="Categoria">
                  <el-select filterable v-model="filters.category" placeholder="Selecione uma categoria" clearable>
                    <el-option 
                      v-for="category in taskCategories" 
                      :key="category.id" 
                      :label="category.name" 
                      :value="category.id" />
                  </el-select>
                </el-form-item>
              </el-col>
        
              <!-- Filtro por Estágio -->
              <el-col :xs="24" :md="12" :lg="6">
                <el-form-item label="Estágio">
                  <el-select v-model="filters.stage" placeholder="Selecione um estágio" clearable>
                    <el-option label="A Fazer" value="0" />
                    <el-option label="Fazendo" value="1" />
                    <el-option label="Pendente" value="2" />
                    <el-option label="Validando" value="3" />
                    <el-option label="Concluída" value="4" />
                    <el-option label="Arquivada" value="5" />
                  </el-select>
                </el-form-item>
              </el-col>
        
              <!-- Filtro por Data de Criação -->
              <el-col :xs="24" :md="12" :lg="6">
                <el-form-item label="Data de Criação">
                  <el-date-picker
                    v-model="filters.creationDate"
                    type="daterange"
                    start-placeholder="Data inicial"
                    end-placeholder="Data final"
                    range-separator="até"
                    unlink-panels                    
                    clearable
                  />
                </el-form-item>
              </el-col>
        
              <!-- Filtro por Data de Início -->
              <el-col :xs="24" :md="12" :lg="6">
                <el-form-item label="Data de Início">
                  <el-date-picker
                    v-model="filters.startDate"
                    type="daterange"
                    start-placeholder="Data inicial"
                    end-placeholder="Data final"
                    range-separator="até"
                    unlink-panels                    
                    clearable
                  />
                </el-form-item>
              </el-col>
        
              <!-- Filtro por Data de Prazo -->
              <el-col :xs="24" :md="12" :lg="6">
                <el-form-item label="Data de Prazo">
                  <el-date-picker
                    v-model="filters.dueDate"
                    type="daterange"
                    start-placeholder="Data inicial"
                    end-placeholder="Data final"
                    range-separator="até"
                    unlink-panels                    
                    clearable
                  />
                </el-form-item>
              </el-col>
            </el-row>
        
            <!-- Botões de Ação -->
            <el-row class="filter-actions">
              <el-col :md="24">                              
                <el-button type="warning" @click="resetFilters">
                  <el-icon><CircleClose /></el-icon>
                  Limpar
                </el-button>
                <el-button type="primary" @click="fetchTasks()" :loading="loadingFilter">
                  <el-icon v-if="!loadingFilter">
                    <Search />
                  </el-icon>
                  Buscar
                </el-button>
              </el-col>
            </el-row>
          </el-card>
        </el-form>

        <!-- Tabela de Tarefas -->
        <el-table :data="tasks" style="width: 100%" v-loading="loading" v-if="!isKanbanView ">
            <el-table-column label="Título">
            <template #default="scope">
              <span @click="viewData(scope.row)" style="cursor: pointer;">
                #{{ scope.row.id }} | {{ scope.row.title }}
              </span>
              <el-tag v-if="scope.row.deadline.overdue" type="danger">
                Em atraso
              </el-tag>
            </template>
            </el-table-column>
          <el-table-column prop="client_name" label="Cliente" />
          <el-table-column prop="responsible_name" label="Realizado por" />
          <el-table-column prop="start_date" label="Iniciado em" />
          <el-table-column prop="expected_date" label="Entregar até" />
          <el-table-column prop="stage_name" label="Status" />
          <el-table-column label="Prioridade">
            <template #default="scope">
              <task-priority :type="scope.row.priority" />
            </template>
          </el-table-column>
          <el-table-column label="Ações">
            <template #default="scope">
              <el-button
                size="small"
                type="success"
                @click="viewData(scope.row)"
                >Visualizar</el-button
              >              
            </template>
          </el-table-column>
        </el-table>


        <KanbanBoard :tasks="tasks" v-if="isKanbanView && tasks.length > 0" />                
        <div class="message-notfound" v-else v-html="returnMessageLoading"></div>
      </div>
    </AuthenticatedLayout>
  </template>
  
<script>
import AuthenticatedLayout from "@/layouts/AuthenticatedLayout.vue";
import KanbanBoard from "@/components/KanbanBoard";
import { getFilter } from "@/services/taskService";
import { mapGetters } from "vuex";
import TaskPriority from "@/components/TaskPriority.vue";
  
export default {
  name: "TasksView",
  components: {
    AuthenticatedLayout,
    KanbanBoard,
    TaskPriority
  },
  data() {
    return {
      showFilters: false,
      loadingFilter: false,
      returnMessageLoading: "Aguarde, carregando tarefas...",
      urlApi: process.env.VUE_APP_API_URL,
      tasks: [],
      loading: false,
      isKanbanView: true,        
      filters: {
        author: '',
        assignedTo: '',
        client: '',
        category: '',
        stage: '',
        creationDate: '',
        startDate: '',
        dueDate: '',
      },                
      stages: [],
    };
  },
  computed: {
    ...mapGetters('taskData', [
        'taskCategories',
        'activeUsers',
        'activeClients',
        'isTaskModalVisible'           
    ])
  },
  methods: {
      async fetchTasks() {
          this.loading = true;
          this.loadingFilter = true;
          try {
            const response = await getFilter(this.filters);
            this.tasks = response.data;

            if (this.tasks.length == 0) {
              this.returnMessageLoading = this.showFilters ? 
                                          'Não encontramos nenhuma tarefa com os parametros informados, você pode tentar outras combinações de filtro.' 
                                          : 'Não há tarefas cadastradas'
            }

            console.log('tarefas da empresas >>> ', this.tasks);

          } catch (error) {              
            this.$message.error("Erro ao carregar tarefas.");
          } finally {
            this.loading = false;
            this.loadingFilter = false;
          }
      },

      filterTask() {                
        this.$emit("filter-tasks", this.filters);
      },
      resetFilters() {
        // Reseta todos os filtros
        this.filters = {
          author: '',
          assignedTo: '',
          client: '',
          category: '',
          stage: '',
          creationDate: '',
          startDate: '',
          dueDate: '',
        };
      },

      toggleView() {            
        this.isKanbanView = !this.isKanbanView;
      },
      viewData(task) {            
          try {
              this.$router.push({
                  name: 'TaskDetails',
                  params: {
                  id: task.id,
                  slug: task.slug
                  }
              });
          } catch (error) {
              console.error('[ERROR AO CARREGAR TAREFAS EM ANDAMENTO] ', error);
              this.$message.error('Erro ao abrir tarefa!');
          }
      },  
  },
  created() {
    this.fetchTasks();  
  },
};
</script>
  
<style scoped>
.tasks-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}
  
.tasks-header h2 {
  font-size: 24px;
  margin: 0;
}
.task-overdue {
  background: #f00;
  color: #fff;
}
  
  .notification-icon {
    cursor: pointer;
  }
  .task-filter h3 {
    margin-bottom: 20px;
    font-size: 1.5rem;
    font-weight: bold;
    color: var(--el-color-primary);
  }
  .filter-actions {    
    text-align: right;

    button {
      i {
        margin-right: 5px;
      }
    }
    
  }
  .message-notfound {
    background: #ccc;
    color: #333;
    padding: 10px;
    border-radius: 5px;
    font-weight: bold;
    text-align: center;
    font-size: 16px;
  }
  </style>
  